/** Usable only after Razorpay checkout completes (card saved or payment captured). */
export const PAID_SUBSCRIPTION_STATUSES = ['active', 'authenticated'] as const;

/** Checkout started but not finished — cannot add locations yet. */
export const PENDING_SUBSCRIPTION_STATUSES = ['pending', 'created'] as const;

export const isPaidSubscriptionStatus = (status?: string): boolean =>
  PAID_SUBSCRIPTION_STATUSES.includes(String(status || '').toLowerCase() as typeof PAID_SUBSCRIPTION_STATUSES[number]);

export const isPendingSubscriptionStatus = (status?: string): boolean =>
  PENDING_SUBSCRIPTION_STATUSES.includes(String(status || '').toLowerCase() as typeof PENDING_SUBSCRIPTION_STATUSES[number]);
